// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"Input_inputContainer__iGGPp","inputBox":"Input_inputBox__S1brf"};